import React from 'react';
import CheckBoxFilter from './CheckBoxFilter';

const PRIORITY_PROVIDERS = [
    'affinity',
    'assist-card',
    'coris',
    'gta',
    'my-travel-assist',
    'sul-america',
    'universal-assistance',
];

const ProviderFilter = ({ useStagingMode = false, onStageChange = null }) => {
    return (
        <CheckBoxFilter
            source="provider"
            title="Seguradoras"
            initialVisibleCount={7}
            showAllLabel="Ver todas seguradoras"
            useStagingMode={useStagingMode}
            onStageChange={onStageChange}
            priorityProviderSlugs={PRIORITY_PROVIDERS}
        />
    );
};

export default ProviderFilter;



// WEBPACK FOOTER //
// ./src/views/v2/search/components/filter/components/ProviderFilter.jsx